import { createRoot } from "react-dom/client";
import App from "./App";
import { initGA } from "./lib/analytics";

// Self-hosted Inter font (eliminates Google Fonts render-blocking request)
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";

import "./index.css";

// Initialize Google Analytics
initGA();

const rootElement = document.getElementById("root");
if (rootElement) {
  createRoot(rootElement).render(<App />);
}

